import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
} from '@mui/material';

const TermsAndConditions = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={1} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Welcome to Pharmaman!
        </Typography>

        <Typography variant="body1" paragraph>
          The terms and conditions as set out herein ("Terms") constitutes an agreement between the Company, and a natural or legal person who accesses and/or uses the Website in any manner ("you" or "your").
        </Typography>

        <Typography variant="body1" paragraph>
          The Website is a platform that facilitates online purchase by consumers of pharmaceutical products like prescription drugs, over the counter medicines etc., sold by Pharmaman through its licensed premises ("Products").
        </Typography>

        <Typography variant="body1" paragraph>
          By using the Website, you expressly agree to be bound by the Terms. If you do not agree with any of the Terms, please refrain from using the Website. Please note that your usage of the Website, the Products, offers or promotions in relation to the Products and the Services (defined below) as may be provided by us or our affiliates or third parties, shall be governed by these Terms and such other terms that may be applicable ("Additional Terms"). If these Terms are inconsistent with any Additional Terms, the Additional Terms will supersede to the extent of the Additional Terms are applicable.
        </Typography>

        <Typography variant="body1" paragraph>
          This document is an electronic record in terms of Information Technology Act, 2000 ("IT Act"), the applicable rules thereunder and the provisions pertaining to electronic records in various statutes as amended by the IT Act. This electronic record is generated by a computer system and does not require any physical or digital signatures.
        </Typography>

        <Typography variant="body1" paragraph>
          Any individual who can enter into legally binding contracts as per Indian Contract Act, 1872, i.e. individuals who are 18 years of age or older, are of sound mind, and are not disqualified from entering into contracts by any law, can use and access the Website.
        </Typography>

        <Typography variant="body1" paragraph>
          THESE TERMS ARE DIVIDED INTO 2 (TWO) PARTS. PLEASE READ THE TERMS CAREFULLY.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          PART A: TERMS FOR USAGE OF THE WEBSITE
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom>
          GENERAL
        </Typography>
        
        <Typography variant="body1" paragraph>
          1.1 Your access, or otherwise any usage of the Website means you agree to these Terms read with all the policies that may be available on the Website (collectively, the "Agreement").
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom>
          REGISTRATION OF YOUR ACCOUNT
        </Typography>
        
        <Typography variant="body1" paragraph>
          2.1 In order to access or use the Website you must set up an account by providing information about yourself as prompted on the sign-up page of the Website which may include your name, gender, mobile number and such other details relevant for placing orders through your account. Your login ID and password will be created basis the information provided by you, which you can use to access your Pharmaman account at any time. Your credentials shared by you at the time of registration and your Pharmaman login ID and password are referred to as "Account Information".
        </Typography>
        
        <Typography variant="body1" paragraph>
          2.2 You are solely authorized to operate the account created by you. Consequently, it is your responsibility to maintain the confidentiality of your Account Information. You shall remain solely responsible for all the actions by you on your account.
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom>
          USER WARRANTIES AND RESTRICTIONS
        </Typography>
        
        <Typography variant="body1" paragraph>
          4.1 You represent and warrant that: (a) your use of the Website will not violate any applicable law or regulation; (b) all information that is submitted to the Company in connection with the Website is true, accurate and lawful; (c) Your use of the Website does not breach any applicable Website policies or guidelines and will not cause injury to any person or entity.
        </Typography>
        
        <Typography variant="body1" paragraph>
          4.2 You will use the Website for a lawful purpose only, and will not undertake any activity that is harmful to the Company or the Website or its content or otherwise not envisaged through the Website. You have a limited license to access and use the Website, solely for the purpose of availing the services, subject to these Terms.
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom>
          WARRANTY AND DISCLAIMER
        </Typography>
        
        <Typography variant="body1" paragraph>
          8.1 The Website, its content, materials and services provided therein are on an "as is" and "as available" basis without any warranties of any kind, including that the Website will operate error-free or that the Website, its servers or its content or service are free of computer viruses or similar contamination or destructive features.
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom>
          LIMITATION OF LIABILITY
        </Typography>
        
        <Typography variant="body1" paragraph>
          9.1 To the maximum extent permitted by applicable law, the Company, its affiliates, employees, officers, partners, licensors or any other related party shall not be liable to you or any third party for any direct, indirect, special, consequential or incidental damages or loss of goodwill, arising out of or in connection with the Website, the services or the Terms.
        </Typography>

        <Typography variant="h6" component="h3" gutterBottom>
          MISCELLANEOUS
        </Typography>
        
        <Typography variant="body1" paragraph>
          11.1 The Company reserves the right to make changes to the Website, related policies and agreements, the Terms of Use and the Privacy Policy at any time as may be required.
        </Typography>
        
        <Typography variant="body1" paragraph>
          11.2 These Terms will be governed by and construed in accordance with the laws of the Republic of India. You agree that the courts at Mumbai, India will have exclusive jurisdiction over any dispute arising between you and the Company.
        </Typography>
      </Paper>
    </Container>
  );
};

export default TermsAndConditions;